(($)=>{

    const blockRootSelector = '.example-dynamic-block'; // can be any css valid selector for wrapper of block
    const blockName = 'exampleDynamicBlock'; // please use `camelCase` for functions and `CamelCase` with first capital if it's class name

    /// All logic and initialization is inside this function.
    function initializeBlock(el){

        // do something with block=> init slider or whatever, add event listeners etc.
        // const $slider = $('.example-slides', el); // please use selectors with parent el set, so jQuery will select only block's childs.
        // $slider.slick({
        //     // some options go here...
        // });

        $(el).html('<code> function example-dynamic-block works. </code>')


        // return  element so later it'll not be reinitialized
        return el;
    }


    //we initialize blocks of this type which are already rendered on page not via ajax.
    $(blockRootSelector).each((index, el) => {

        const blockId = `wpshopify_initial_${blockName}_${index}`;

        window.WPShopify.blockInstances[blockId] = {
            el: el,
            id: blockId,
            blockInitFunctionName: blockName,
            instance: initializeBlock(el)
        };

    });

    // save our block initializer function to storage to make it possible to init blocks of same type loaded by ajax.
    window.WPShopify.blocksInits[blockName] = initializeBlock;


})(jQuery);

